import { useState } from 'react'
import { useAspectRatioSwitch } from 'hooks/useAspectRatioSwitch'
import { ASPECT_RATIO_WARNING_STORAGE_KEY, TCanvasSizeKey } from 'consts'

export const useAspectRatioWarning = () => {
  const { canSwitch, performSwitch } = useAspectRatioSwitch()
  const [showWarning, setShowWarning] = useState(false)
  const [pendingSelection, setPendingSelection] =
    useState<TCanvasSizeKey | null>(null)

  const handleAspectRatioClick = (targetKey: TCanvasSizeKey) => {
    if (!canSwitch) {
      return
    }

    const hasSeenWarning = sessionStorage.getItem(
      ASPECT_RATIO_WARNING_STORAGE_KEY
    )

    if (!hasSeenWarning) {
      setPendingSelection(targetKey)
      setShowWarning(true)
      return
    }

    performSwitch(targetKey)
  }

  const handleConfirmSwitch = () => {
    sessionStorage.setItem(ASPECT_RATIO_WARNING_STORAGE_KEY, 'true')

    if (pendingSelection) {
      performSwitch(pendingSelection)
    }

    setShowWarning(false)
    setPendingSelection(null)
  }

  const handleCancelSwitch = () => {
    setShowWarning(false)
    setPendingSelection(null)
  }

  return {
    canSwitch,
    handleAspectRatioClick,
    showWarning,
    pendingSelection,
    handleConfirmSwitch,
    handleCancelSwitch
  }
}
